import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  InputBase,
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';

import { formatDateTimeToRender } from '../../../../utils/functions';

import useStyles from './style';
import { Input } from '@material-ui/icons';

function Render({ inputs, getAncoras, getCargos, getLoading, onSubmit }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Visualizando contato da rede: " back={false} subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {getLoading ? (
            <Loading />
          ) : (
            <>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          min
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome"
                          value={inputs.nome}
                          required
                          readOnly
                          name="nome"
                          onBlur
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          required
                          value={inputs.status}
                          name="status"
                          disabled
                        >
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                        </select>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          type="email"
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="E-mail"
                          value={inputs.email}
                          required
                          readOnly
                          name="email"
                          onBlur
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={4}>
                      <label className={classes.label}>Telefone 1</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          readOnly
                          value={inputs.telefone1}
                          name="telefone1"
                          className={classes.input}
                          placeholder="Telefone 1"
                          inputProps={{ 'aria-label': 'telefone 1' }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Ramal 1</label>
                      <Paper className={classes.medium} elevation={0} style={{ width: '91%' }}>
                        <InputBase
                          readOnly
                          value={inputs.ramal1}
                          name="ramal1"
                          className={classes.input}
                          placeholder="Ramal 1"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={4} className={classes.item} style={{ paddingLeft: '7px' }}>
                      <label className={classes.label}>Telefone 2</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          value={inputs.telefone2}
                          name="telefone2"
                          className={classes.input}
                          placeholder="Telefone 2"
                          inputProps={{ 'aria-label': 'telefone 2' }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2} className={classes.item}>
                      <label className={classes.label} style={{ width: '90%' }}>
                        Ramal 2
                      </label>
                      <Paper className={classes.medium} elevation={0} style={{ width: '91%' }}>
                        <InputBase
                          readOnly
                          value={inputs.ramal2}
                          name="ramal2"
                          className={classes.input}
                          placeholder="Ramal 2"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>
                        Receber Email das Antecipacoes Aprovadas
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          value={inputs.receberEmailAntecipacoesAprovadas}
                          name="receberEmailAntecipacoesAprovadas"
                          disabled
                        >
                          <option value="NaoRecebe">Não Recebe</option>
                          <option value="RecebePrincipal">Recebe Principal</option>
                          <option value="RecebeCopia">Recebe Cópia</option>
                        </select>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Receber Email de Fechamento do Mes</label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          value={inputs.receberEmailFechamentoMes}
                          name="receberEmailFechamentoMes"
                          disabled
                        >
                          <option value="NaoRecebe">Não Recebe</option>
                          <option value="RecebePrincipal">Recebe Principal</option>
                          <option value="RecebeCopia">Recebe Cópia</option>
                        </select>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cargo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          required
                          value={inputs.cargoId}
                          name="cargoId"
                          disabled
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getCargos.map((cargo) => (
                            <option key={cargo.cargoId} value={cargo.cargoId}>
                              {cargo.cargo}
                            </option>
                          ))}
                        </select>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Dados do Registro</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Data de Registro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                          readOnly
                          placeholder="Data do Registro"
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Data da Atualização</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          value={
                            inputs.dataAtualizacao
                              ? formatDateTimeToRender(inputs.dataAtualizacao)
                              : ''
                          }
                          readOnly
                          placeholder="Data da Atualização"
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Render;
